import React from "react"

const PlanetImage = ({
  image, name, isFull
}) => {
  if (isFull) { isFull  = '100%' } else {
    isFull = 'fit-content'
  }
  
  return (
    <img src={image} alt={name} width={isFull}/>
  )
}

export default PlanetImage